var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAssets = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M15 2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-4.623 6.103-.084.063-1.835 1.613-1.076-.946-.088-.066a.67.67 0 0 0-.704 0l-.088.066-2.274 2-.07.07a.668.668 0 0 0 .41 1.09l.1.007h8.664l.101-.007a.668.668 0 0 0 .442-1.048l-.066-.077L11.21 8.2l-.079-.069a.67.67 0 0 0-.754-.029M13 0a1 1 0 0 1 1 1H3a2 2 0 0 0-1.995 1.85L1 3v9a1 1 0 0 1-1-1V3a3 3 0 0 1 3-3zM6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
})));
export default SvgAssets;